module.exports = __webpack_public_path__ + "static/customer-image-913d3a17a107fe2184d064a6ced3afc4.jpg";